module.exports = __webpack_public_path__ + "media/images/application/template/map-cluster-markers/m5-d611651cc0c24df92923d89ee68f8287.png";